import React, { FC } from "react";
import { usePlanner } from "./PlannerContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDay, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { useModal } from "@traas/lib/src/components/layout/ModalProvider";
import { PickDayModal } from "../modals/PickDayModal";
import { getWeek } from "@traas/lib/src/util/getWeekNumber";
export const WeekPicker: FC = () => {
  const { day, setDay } = usePlanner();
  const now = moment();
  const value = moment(day);

  const pickDayModal = useModal({
    title: "Datum selecteren",
    body: <PickDayModal current={day} onDaySelected={setDay} />,
  });

  return (
    <div className={"flex items-center"}>
      <div className={"flex items-center relative gap-1"}>
        <button
          className={"hidden 2xl:block h-8 w-8 rounded-full hover:bg-gray-200"}
          onClick={() => setDay(value.clone().subtract(5, "week").toDate())}
        >
          <div className={"flex"}>
            <FontAwesomeIcon icon={faChevronLeft} />
            <FontAwesomeIcon icon={faChevronLeft} className={"-ml-3"} />
          </div>
        </button>
        <button
          className={"h-8 w-8 rounded-full hover:bg-gray-200"}
          onClick={() => setDay(value.clone().subtract(1, "week").toDate())}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <button
          className={"hidden 2xl:block w-8 py-1 rounded-sm text-sm text-brand-300 hover:bg-slate-200 font-medium"}
          onClick={() => setDay(value.clone().subtract(4, "week").toDate())}
        >
          {getWeek(value.clone().subtract(4, "week"))}
        </button>
        <button
          className={"hidden xl:block w-8 py-1 rounded-sm text-sm text-brand-400 hover:bg-slate-200 font-medium"}
          onClick={() => setDay(value.clone().subtract(3, "week").toDate())}
        >
          {getWeek(value.clone().subtract(3, "week"))}
        </button>
        <button
          className={"hidden xl:block w-8 py-1 rounded-sm text-sm text-brand-500 hover:bg-slate-200 font-medium"}
          onClick={() => setDay(value.clone().subtract(2, "week").toDate())}
        >
          {getWeek(value.clone().subtract(2, "week"))}
        </button>
        <button
          className={"w-8 py-1 rounded-sm text-sm text-brand-600 hover:bg-slate-200 font-medium"}
          onClick={() => setDay(value.clone().subtract(1, "week").toDate())}
        >
          {getWeek(value.clone().subtract(1, "week"))}
        </button>
        <div className={"w-10 py-1 font-bold relative"}>
          <span className={"h-10 w-10 rounded-full flex items-center justify-center border-2 border-brand-900"}>
            {getWeek(value)}
          </span>
          <div
            className={
              "absolute -bottom-1 left-1/2 -translate-x-1/2 font-medium text-xs h-4 bg-brand-900 rounded-sm text-white px-1"
            }
          >
            {value.isoWeekYear()}
          </div>
        </div>
        <button
          className={"w-8 py-1 rounded-sm text-sm text-brand-600 hover:bg-slate-200 font-medium"}
          onClick={() => setDay(value.clone().add(1, "week").toDate())}
        >
          {getWeek(value.clone().add(1, "week"))}
        </button>
        <button
          className={"hidden xl:block w-8 py-1 rounded-sm text-sm text-brand-500 hover:bg-slate-200 font-medium"}
          onClick={() => setDay(value.clone().add(2, "week").toDate())}
        >
          {getWeek(value.clone().add(2, "week"))}
        </button>
        <button
          className={"hidden xl:block w-8 py-1 rounded-sm text-sm text-brand-400 hover:bg-slate-200 font-medium"}
          onClick={() => setDay(value.clone().add(3, "week").toDate())}
        >
          {getWeek(value.clone().add(3, "week"))}
        </button>
        <button
          className={"hidden 2xl:block w-8 py-1 rounded-sm text-sm text-brand-300 hover:bg-slate-200 font-medium"}
          onClick={() => setDay(value.clone().add(4, "week").toDate())}
        >
          {getWeek(value.clone().add(4, "week"))}
        </button>
        <button
          className={"h-8 w-8 rounded-full hover:bg-gray-200"}
          onClick={() => setDay(value.clone().add(1, "week").toDate())}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
        <button
          className={"hidden 2xl:block h-8 w-8 rounded-full hover:bg-gray-200"}
          onClick={() => setDay(value.clone().add(5, "week").toDate())}
        >
          <div className={"flex"}>
            <FontAwesomeIcon icon={faChevronRight} />
            <FontAwesomeIcon icon={faChevronRight} className={"-ml-3"} />
          </div>
        </button>
      </div>
      {(getWeek(now) !== getWeek(value) || now.year() !== value.year()) && (
        <>
          <button
            className={
              "text-sm font-medium text-brand-600 hover:bg-slate-200 w-8 2xl:px-4 2xl:w-auto h-8 rounded-full py-1"
            }
            onClick={() => setDay(new Date())}
          >
            <FontAwesomeIcon icon={faCalendarDay} />
            <span className={"ml-2 hidden 2xl:inline"}>Naar deze week</span>
          </button>
        </>
      )}
      <button
        className={
          "text-sm font-medium text-brand-600 hover:bg-slate-200 w-8 2xl:px-4 2xl:w-auto h-8 rounded-full py-1"
        }
        onClick={() => pickDayModal.open()}
      >
        <FontAwesomeIcon icon={faCalendar} />
        <span className={"ml-2 hidden 2xl:inline"}>Selecteer week</span>
      </button>
    </div>
  );
};
